// extracted by mini-css-extract-plugin
export default {"pageDiv":"App_pageDiv__lZ7ii","inner":"App_inner__LGCSN","SignupDiv":"App_SignupDiv__KZX03"};